import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=2a42b908&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=2a42b908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42b908",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VSelect,VSkeletonLoader,VSnackbar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a42b908')) {
      api.createRecord('2a42b908', component.options)
    } else {
      api.reload('2a42b908', component.options)
    }
    module.hot.accept("./Pricing.vue?vue&type=template&id=2a42b908&scoped=true&", function () {
      api.rerender('2a42b908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pricing.vue"
export default component.exports